import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerSuccessOptionsAppserviceService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetVendorSelfRolesByCompany = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  companyId: string
): UseQueryResult<Array<{ label: string; value: string }> | undefined, unknown> => {
  return useQuery(
    ['getVendorSelfRolesByCompany', companyId],
    async () => {
      return await handleRequest(
        CustomerSuccessOptionsAppserviceService.getApiCustomerApiCustomerCustomerSuccessVendorOptionsSelfRoles(
          companyId
        )
      );
    },
    {
      enabled: !!companyId,
      select(data) {
        return data?.map((role) => ({
          label: role.name ?? '',
          value: role.id ?? '',
        }));
      },
    }
  );
};

export default useGetVendorSelfRolesByCompany;
